import { useMutation, useQueryClient } from '@tanstack/react-query'
import { authService } from '../../service/domain/_service.config'
import { USER_QUERY_KEY } from '../user/useUser'

export function useSignIn() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ email, password }: { email: string; password: string }) => {
      await authService.signIn(email, password)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: USER_QUERY_KEY })
    },
  })
}
